import { render } from "./AdminWorkGroups.vue?vue&type=template&id=3ebbad47&scoped=true"
import script from "./AdminWorkGroups.vue?vue&type=script&lang=js"
export * from "./AdminWorkGroups.vue?vue&type=script&lang=js"

import "./AdminWorkGroups.vue?vue&type=style&index=0&id=3ebbad47&scoped=true&lang=css"

import exportComponent from "/var/www/boa/bo/frontend/boa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ebbad47"]])

export default __exports__